export const useSceneStore = defineStore('scene', {
  state: () => ({
    scene: null,
  }),
})
